import { env } from "@/env";
import { getSession } from "@/utils/getSession";
import { type FetchFunction, Network } from "relay-runtime";

const backendUrl = env.VITE_SERVER_URL as string;

const graphqlUrl = new URL(backendUrl);
graphqlUrl.pathname = "/graphql";
const graphqlEndpoint = graphqlUrl.toString();

export const noAuthFetcher = () => {
	const fetcher: FetchFunction = async (request, variables) => {
		const resp = await fetch(graphqlEndpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ query: request.text, variables }),
		});

		if (!resp.ok) {
			throw new Error("Response failed.");
		}

		return await resp.json();
	};

	return fetcher;
};

const createFetcher = () => {
	const fetcher: FetchFunction = async (request, variables) => {
		const session = await getSession();

		const resp = await fetch(graphqlEndpoint, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...(session?.accessToken
					? {
							Authorization: `Bearer ${session?.accessToken}`,
						}
					: {}),
			},
			body: JSON.stringify({ query: request.text, variables }),
		});

		if (!resp.ok) {
			throw new Error("Response failed.");
		}

		return await resp.json();
	};

	return fetcher;
};

export const relayNetwork = Network.create(createFetcher());
